import script from "./view-product-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./view-product-detail.vue?vue&type=script&setup=true&lang=js"

import "./view-product-detail.vue?vue&type=style&index=0&id=b1de9fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1de9fcc"]])

export default __exports__